import React from 'react'

export const HashTagActiveSvg = ({
  size = 24,
  className = '',
  customIdFirst = 'prefix_hash_upper',
  customIdSecond = 'prefix_hash_downer',
}) => {
  const fillA = `url(#${customIdFirst})`
  const fillB = `url(#${customIdSecond})`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
    >
      <defs>
        <linearGradient
          id={customIdFirst}
          x1="-21.739%"
          x2="108.73%"
          y1="395.337%"
          y2="395.337%"
        >
          <stop offset="0%" stopColor="#85C2F4" />
          <stop offset="100%" stopColor="#45AAED" />
        </linearGradient>
        <linearGradient
          id={customIdSecond}
          x1="-23.874%"
          x2="108.73%"
          y1="395.337%"
          y2="395.337%"
        >
          <stop offset="1.61%" stopColor="#85C2F4" />
          <stop offset="100%" stopColor="#45AAED" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#6DB9F1"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.5"
          d="M9.811 4L6.22 20.789"
        />
        <path
          stroke="#55B0EE"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.5"
          d="M18.282 4L14.691 20.789"
        />
        <path
          fill={fillA}
          fillRule="nonzero"
          d="M22.22 6.832c.966 0 1.75.783 1.75 1.75 0 .918-.708 1.671-1.607 1.744l-.144.006H3.21c-.966 0-1.75-.784-1.75-1.75 0-.918.707-1.671 1.607-1.744l.143-.006h19.01z"
        />
        <path
          fill={fillB}
          fillRule="nonzero"
          d="M21.362 14.697c.966 0 1.75.784 1.75 1.75 0 .919-.707 1.672-1.607 1.745l-.143.005H2c-.966 0-1.75-.783-1.75-1.75 0-.918.707-1.67 1.606-1.744L2 14.697h19.362z"
        />
      </g>
    </svg>
  )
}
